import React from 'react';
import classes from './FullWidth.module.scss';
import renderHTML from 'react-render-html';
import globalJSON from '../../../../../data/global';
import { getFileName } from 'helpers/FileCaching';
import { Link  } from "react-router-dom";
const globalImages = require.context('images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);
const latestThumbnails = require.context('images/components/Latest', true, /.*\.(gif|png|jpe?g|svg)$/i);


function FullWidth(props) {

    let overlay;
    let content = props.content;

    const externalElement = content.externalUrl;
    const internalElement = content.internalUrl;

    const showOverlay = props.content.overlay;

    if(showOverlay !== '' && showOverlay === 'true'){
        overlay = <div className={`overlay_title`}></div>
    }

    function onFullWidthClick(event){
		window.gtag('event', "Latest article selection", {
			'event_category': globalJSON.tracking.ga_category,
			'event_label': "promo article clicked "+ event,
			'value':10
        });
        
	}

    function onItemClick(){
        // props.onSelected(props.content.internalUrl)
        // console.log('ciao')
    }

    const element = (
        <div className={`black_arrow_btn_hover remove-img-color-hero smooth`}>
            <div className={`container-fluid`}>
                <div className={`row`}> 
                    <div className={`${classes.FullWidth__image_container} remove-img-element-hero`}>
                        <img className={` ${classes.FullWidth__image} `} alt={content.thumbnailTitle} src={getFileName(latestThumbnails, content.thumbnail[props.windowSize])}></img>
                        {overlay}
                    </div>
                </div> 
                <div className={`${classes.FullWidth__content_container}`}>
                    <div className={`row`} style={{margin:0}}> 
                        {/* <div className={`col-10 col-md-8 col-lg-5`}> */}
                        <div className={`${classes.FullWidth__content_wrap}`}>
                            <p className={`subtitle_white_global ${classes.FullWidth__subtitle}`}>{renderHTML(content.subtitle)}</p>
                            <h3 className={classes.FullWidth__title}>{renderHTML(content.title)}</h3>
                            <div className={`divider_white`}></div>
                            <p className={classes.FullWidth__excerpt}>{renderHTML(content.excerpt)}</p>
                        </div>
                        <div className={`col-10 col-md-4 col-lg-5`}>
                            <div className={classes.FullWidth__btn_container}>
                                <img className={`black_arrow_btn ${classes.FullWidth__btn}`} src={getFileName(globalImages, 'arrow_right.svg')} alt={`arrow right`} />
                            </div>
                        </div>
                    </div> 
                </div> 
            </div> 
        </div>
    );



    return (
        <section className={`${classes.FullWidth}`}>
            { externalElement ? <a href={props.content.externalUrl} target='_blank' rel="noopener noreferrer"
                                    onClick={() => onFullWidthClick(content.externalUrl)}>
                                    {element}
                                </a> 
                : internalElement ? <Link to={process.env.PUBLIC_URL+props.content.internalUrl}
                                        onClick={() => onFullWidthClick(content.internalUrl)}>
                                        {element}
                                    </Link>
                : null 
            }
            {/* <Link to={process.env.PUBLIC_URL+content.internalUrl}
                onClick={() => onFullWidthClick(content.internalUrl)}>
                {element}
            </Link>  */}
        </section>
    )

}

export default FullWidth;